import styled, { keyframes } from 'styled-components'

export const StyledLoadingButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
`

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const StyledLogo = styled.div`
  margin-top: 8px;
  transform-origin: 8px 8px;
  animation: ${rotateAnimation} 1s linear infinite;
`
